document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', function(e) {
    const thumbnail = e.target.closest('.quickView_thumbnail');
    if (!thumbnail) return;

    const largeSrc = thumbnail.dataset.largeSrc;
    const largeSrcset = thumbnail.dataset.largeSrcset;
    const alt = thumbnail.querySelector('img')?.alt || '';
    
    if (!largeSrc) return;

    const wrapper = thumbnail.closest('.quick__View_img_wrapper');
    if (!wrapper) return;

    // Update active thumbnail
    wrapper.querySelectorAll('.quickView_thumbnail').forEach(t => t.classList.remove('active'));
    thumbnail.classList.add('active');

    // Update main image
    const mainImage = wrapper.querySelector('.quickView_main_image img');
    if (mainImage) {
      mainImage.src = largeSrc;
      mainImage.srcset = largeSrcset || '';
      mainImage.alt = alt;
    }
  });
});
